import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { getCookie, setCookie } from '../utils/Cookie';
import { AFFILIATE_COOKIE_KEYS } from '../constants/Affiliate';
import { generateVisitorId } from '../utils/Affiliate';
import { sendAffiliateClick } from '../api/AffiliatePublic';

export const useAffiliateTracking = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const aff = searchParams.get('aff');

    if (aff) {
      const existingAffiliate = getCookie(AFFILIATE_COOKIE_KEYS.AFFILIATE_CODE);
      if (!existingAffiliate) {
        setCookie(AFFILIATE_COOKIE_KEYS.AFFILIATE_CODE, aff, 30);
      }

      let visitorID = getCookie(AFFILIATE_COOKIE_KEYS.AFFILIATE_VISITOR_ID);
      if (!visitorID) {
        visitorID = generateVisitorId();

        setCookie(AFFILIATE_COOKIE_KEYS.AFFILIATE_VISITOR_ID, visitorID, 30);
      }

      // eslint-disable-next-line no-console
      sendAffiliateClick().catch((err) => console.error(err));
    }
  }, [searchParams]);
};
